import React from 'react';
import Link from 'next/link';
import clsx from 'clsx';
import { usePathname } from 'next/navigation';
import { ROUTES } from '@/config/routes';
import { useTranslate } from '@tolgee/react';

interface NavigationLinksProps {
  isMobile?: boolean;
  onLinkClick?: () => void;
}

const NavigationLinks: React.FC<NavigationLinksProps> = ({ isMobile, onLinkClick }) => {
  const pathname = usePathname();
  const isActive = (path: string) => pathname === path;
  const { t } = useTranslate();

  const links = [
    { href: ROUTES.HOME, label: t('navigation.main.home.label') },
    { href: ROUTES.LIBRARY, label: t('navigation.main.media_library.label') },
    { href: ROUTES.LIVE_COURSES, label: t('navigation.main.live_class.label') },
    { href: ROUTES.EXPERTS, label: t('navigation.main.experts.label') },
    { href: ROUTES.PARTNERS, label: t('navigation.main.apps_courses.label') },
  ];

  return (
    <nav
      className={clsx({
        'flex flex-col gap-5 text-left w-full': isMobile,
        'flex items-center h-full ml-10 2xl:ml-20': !isMobile,
      })}
    >
      {links.map((link) => (
        <div
          key={link.href}
          className={clsx('relative', {
            '': isMobile,
            'px-4': !isMobile,
          })}
        >
          <Link
            href={link.href}
            onClick={isMobile ? onLinkClick : undefined}
            className={clsx('tracking-wide text-lg relative ', {
              block: isMobile,
              'flex items-center h-full': !isMobile,
            })}
          >
            <span className="relative">
              {isActive(link.href) && (
                <span
                  className={clsx(
                    'absolute w-2 h-2 rounded-full bg-primary',
                    isMobile
                      ? '-left-4 top-1/2 -translate-y-1/2'
                      : '-left-4 top-1/2 -translate-y-1/2',
                  )}
                  aria-hidden="true"
                />
              )}
              {link.label}
            </span>
          </Link>
        </div>
      ))}
    </nav>
  );
};

export default NavigationLinks;
